/* eslint-disable */

import axios from "axios";
require("../../config/development");
import Vue from "vue";

import moment from "moment";

const state = {
  ckycData: [],
  loading: false,
  fileUrl: null,
  userCkycData: null,
  copyUserCKycData: null,
  pdf: null,
  cancelChanges: false,
  kycStatus: null,
  croppedImgUrl: null,
  sortByCreatedDate:null,
  sortByUpdatedDate:null,
  tabs: [
    {
      name: "Personal",
      checkDetails: {
        name: false,
        dob: false,
      },
      isReject: true
    },
    {
      name: "Address",
      checkDetails: { address_status: false , address_validity: false},
      isReject: true
    },
    {
      name: "IPV",
      checkDetails: { gender: false, video: false },
      isReject: true
    },
    { name: "Approve", isReject: true }
  ]
};
const self = Vue.app;
// getters
const getters = {
  getCkycDetails: state => {
    return state.userCkycData;
  },
  // getPdfURl: state => {
  //   return state.pdf;
  // },

  getCKycDetailsById: state => id => {
    return state.ckycData.find(element => element.id === id);
  },

  getFilterKycInfoByCkycStatus: state => status => {
    return state.ckycData.filter(
      element => element.attributes.status === status
    );
  },

  getCKycStatusForApproval: state => {
    return state.userCkycData && (state.userCkycData.status ==='update_verification_pending'|| state.userCkycData.status=='upload_verification_pending' || state.userCkycData.status=='rejected' || state.userCkycData.status=='failed')
  },
};

// actions
const actions = {
  fetchCkycData(context, payload) {
    let status = payload;
    // if(["verification_pending"].includes(payload)) {
    //   status = 'verification_pending'
    // } else if(["upload_pending","uploaded","failed","rejected"].includes(payload)) {
    //   status = 'approved_and_uploaded'
    // }

    context.commit("toggleLoading", true);
    let admin_partner = context.rootGetters.admin_partner

    let end_point = Vue.config.EL_DORADO_API_URL
    if (admin_partner == "az"){
      end_point = Vue.config.EL_DORADO_API_URL_BIGCO
    }    
    return axios
      .get(
        `${end_point}/admin/adfes433fkdfggs343434/ckyc.json?status=${status}`
      )
      .then(response => {
        console.log("ckycData response", response)
        context.commit("saveCkycDetails", response);
        context.commit("toggleLoading", false);
      })
      .catch(function() {
        context.commit("toggleLoading", false);

        return new Promise((resolve, reject) => reject());
      });
  },
  async ckycDetailsByID(context, payload) {
    let images_required = payload.images_required || ''
    let admin_partner = context.rootGetters.admin_partner
    let end_point = Vue.config.EL_DORADO_API_URL
    if (admin_partner == "az"){
      end_point = Vue.config.EL_DORADO_API_URL_BIGCO
    }      
    return axios
      .get(
        `${end_point}/admin/adfes433fkdfggs343434/ckyc/${payload.id}.json?images_required=${images_required}`
      )
      .then(response => {
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Data is loaded successfully",
          succesFlag: true
        });
        // context.commit("setNotifyFlag", true);
        context.commit("saveUserCKycData", response.data);
        context.commit("saveCopyUserCKycData", response.data);
        return response;
      })
      .catch(function() {
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Error in fetching data..",
          succesFlag: false
        });
      });
  },

  ckycfetchPdf(context, payload) {
    context.dispatch("getUrlTokenCkyc");

    context
      .dispatch("getUrlTokenCkyc")
      .then(function(resp) {
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "PDF is loaded successfully",
          succesFlag: true
        });
        let redirect_uri =
          Vue.config.EL_DORADO_API_URL +
          `/admin/adfes433fkdfggs343434/kyc/${payload.id}/${payload.key}.pdf?auth_token=${resp.data.token}`;
        window.open(redirect_uri, "_blank");
        context.commit("savePDFUrl", redirect_uri);
      })
      .catch(err =>
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Error in loading pdf..",
          succesFlag: false
        })
      );
  },

  getUrlTokenCkyc(context) {
    let admin_partner = context.rootGetters.admin_partner
    let end_point = Vue.config.EL_DORADO_API_URL
    if (admin_partner == "az"){
      end_point = Vue.config.EL_DORADO_API_URL_BIGCO
    }      
    return axios
      .get(`${end_point}//api/v3/user/get_token.json`)
      .then(response => new Promise((resolve, reject) => resolve(response)))
      .catch(err => new Promise((resolve, reject) => reject(err)));
  },
  uploadFileCkyc(context, payload) {
    let admin_partner = context.rootGetters.admin_partner
    let end_point = Vue.config.EL_DORADO_API_URL
    if (admin_partner == "az"){
      end_point = Vue.config.EL_DORADO_API_URL_BIGCO
    }      
    let formdata = new FormData();
    formdata.append("attachment", payload.file);
    formdata.append("type", payload.file.type);
    axios
      .put(`${end_point}/admin/adfes433fkdfggs343434/upload/file.json`, formdata)
      .then(response => {
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Successfully upload pdf..",
          succesFlag: true
        });
        let ckyc = {
          status: "",
          remarks: "",
          ckyc_audit: {
            user_ckyc_info: {},
            user_ckyc_identities: {},
            user_ckyc_identity_images: {}
          }
        };
        if (
          payload.key == "file_signature" ||
          payload.key === "file_kyc_form"
        ) {
          if (payload.key === "file_kyc_form")
            context.commit("saveFileURL", response.data.file_url);
          ckyc.ckyc_audit.user_ckyc_identity_images[payload.key] = response.data.file_url;
        } else {
          ckyc.ckyc_audit.user_ckyc_identity_images[payload.key] = response.data.file_url;
        }

        context.dispatch("submitCkycQuery", { data: ckyc, id: payload.id });
        context.commit("updateCKycDetail", payload);
      })
      .catch(() =>
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Error in uploading pdf..",
          succesFlag: false
        })
      );
  },
  async uploadImageCkyc(context,payload){
    let obj = {name: payload.name,image: payload.image,type:payload.key}
    let admin_partner = context.rootGetters.admin_partner
    let end_point = Vue.config.EL_DORADO_API_URL
    if (admin_partner == "az"){
      end_point = Vue.config.EL_DORADO_API_URL_BIGCO
    }      
    return axios
    .put(`${end_point}/admin/adfes433fkdfggs343434/upload/image.json`, obj)
    .then(response => {
      context.commit("SHOW_NOTIFICATION", {
        showNotification: true,
        message: "Successfully upload image..",
        succesFlag: true
      });
      let ckyc = {
        status: "",
        remarks: "",
        ckyc_audit: {
          user_ckyc_info: {},
          user_ckyc_identities: {},
          user_ckyc_identity_images: {}
        }
      };
      if (
        payload.key == "file_signature" ||
        payload.key === "file_kyc_form"
      ) {
        if (payload.key === "file_kyc_form")
          context.commit("saveFileURL", response.data.file_url);
        ckyc.ckyc_audit.user_ckyc_identity_images[payload.key] = response.data.file_url;
      } else {
        ckyc.ckyc_audit.user_ckyc_identity_images[payload.key] = response.data.file_url;
      }
      context.dispatch("submitCkycQuery", { data: ckyc, id: payload.id });
      context.commit("updateCKycDetail", payload);
      console.log(response,'inupload')
      return response;
    })
    .catch(() =>
      context.commit("SHOW_NOTIFICATION", {
        showNotification: true,
        message: "Error in uploading image..",
        succesFlag: false
      })
    );
  },
  updateCKycDetail(context, payload) {
    let obj = {};
    let ckycData = payload.data;

    let user_ckyc_info = {} 
    let user_ckyc_identities = {}
    let user_ckyc_identity_images = {}
    user_ckyc_info.fullname  = ckycData.fullname
    user_ckyc_info.father_fullname  = ckycData.father_fullname
    user_ckyc_info.mother_fullname = ckycData.mother_fullname
    user_ckyc_info.spouse_fullname = ckycData.spouse_fullname  
    user_ckyc_info.pan_number = ckycData.pan_number
    user_ckyc_info.date_of_birth  = ckycData.date_of_birth
    user_ckyc_info.corres_line1  = ckycData.corres_line1
    user_ckyc_info.corres_line2  = ckycData.corres_line2
    user_ckyc_info.corres_line3  = ckycData.corres_line3    
    user_ckyc_info.corres_city  = ckycData.corres_city
    user_ckyc_info.corres_state  = ckycData.corres_state    
    user_ckyc_info.corres_country  = ckycData.corres_country
    user_ckyc_info.corres_pin  = ckycData.corres_pin
    user_ckyc_info.perm_line1 = ckycData.corres_line1
    user_ckyc_info.perm_line2 = ckycData.corres_line2
    user_ckyc_info.perm_line3 = ckycData.corres_line3 
    user_ckyc_info.perm_city = ckycData.corres_city
    user_ckyc_info.perm_country = ckycData.corres_country     
    user_ckyc_info.perm_pin = ckycData.corres_pin
    user_ckyc_info.perm_state = ckycData.corres_state      
    user_ckyc_info.email = ckycData.email
    user_ckyc_info.gender = ckycData.gender
    user_ckyc_info.mobile_number = ckycData.mobile_number

    user_ckyc_identities.ckyc_identity_number = ckycData.ckyc_identity_number || ''
    user_ckyc_identities.ckyc_identity_type = ckycData.ckyc_identity_type || ''
    user_ckyc_identity_images.url_poa_corr_side1 = ckycData.url_poa_corr_side1
    user_ckyc_identity_images.url_photo = ckycData.url_photo
    user_ckyc_identity_images.url_poi_side1 = ckycData.url_poi_side1
    user_ckyc_identity_images.file_signature = ckycData.file_signature

    let ckyc = {
      status: "",
      remarks: "",
      ckyc_audit: {
        user_ckyc_info: user_ckyc_info,
        user_ckyc_identities: user_ckyc_identities,
        user_ckyc_identity_images: {}
      }
    };
    obj.data = ckyc;
    obj.id = payload.id;
    context
      .dispatch("submitCkycQuery", obj)
      .then(() =>
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Successfully update kycInfo..",
          succesFlag: true
        })
      )
      .catch(() =>
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Error while updating kycInfo..",
          succesFlag: false
        })
      );
  },
  submitCkycQuery(context, payload) {
    console.log({submitdata:payload.data.ckyc_audit})
    if (payload.data.ckyc_audit.user_ckyc_info) {
      if (payload.data.ckyc_audit.user_ckyc_info.date_of_birth)
        payload.data.ckyc_audit.user_ckyc_info.date_of_birth = moment(
          payload.data.ckyc_audit.user_ckyc_info.date_of_birth
        ).format("YYYY-MM-DD");
      // if (payload.data.ckyc_audit.kyc.validity_doc_poa_corr && moment(payload.data.ckyc_audit.kyc.validity_doc_poa_corr).isValid()){
      //   console.log(payload.data.ckyc_audit.kyc.validity_doc_poa_corr);
      //   console.log(moment(payload.data.ckyc_audit.kyc.validity_doc_poa_corr).isValid())
      //   payload.data.ckyc_audit.kyc.validity_doc_poa_corr = moment(
      //     payload.data.ckyc_audit.kyc.validity_doc_poa_corr
      //   ).format("DD/MM/YYYY");
      // }
      // console.log(payload.data.ckyc_audit.kyc.validity_doc_poa_corr);
    }
    console.log({submitPayload: payload.data.ckyc_audit})
    let data = { ckyc: payload.data };
    let admin_partner = context.rootGetters.admin_partner
    let end_point = Vue.config.EL_DORADO_API_URL
    if (admin_partner == "az"){
      end_point = Vue.config.EL_DORADO_API_URL_BIGCO
    }      
    return axios
      .put(
        `${end_point}/admin/adfes433fkdfggs343434/ckyc/${payload.id}.json`,
        data
      )
      .then(response => {
        context.dispatch("ckycDetailsByID", payload);
        Promise.resolve(response);
      })
      .catch(err => Promise.reject(err));
  },

  mapCKycDetails(data){
    let user_ckyc_info = {} 
    user_ckyc_info.fullname = data.fullname
    user_ckyc_info.father_fullname = data.father_fullname
    user_ckyc_info.mother_fullname= data.mother_fullname
    user_ckyc_info.spouse_fullname= data.spouse_fullname  
    user_ckyc_info.pan_number= data.pan_number
    user_ckyc_info.date_of_birth = data.date_of_birth
    user_ckyc_info.corres_line1 = data.corres_line1
    user_ckyc_info.corres_line2 = data.corres_line2
    user_ckyc_info.corres_line3 = data.corres_line3    
    user_ckyc_info.corres_city = data.corres_city
    user_ckyc_info.corres_state = data.corres_state    
    user_ckyc_info.corres_country = data.corres_country
    user_ckyc_info.corres_pin = data.corres_pin
    user_ckyc_info.perm_line1= data.perm_line1
    user_ckyc_info.perm_line2= data.perm_line2
    user_ckyc_info.perm_line3= data.perm_line3 
    user_ckyc_info.perm_city= data.perm_city
    user_ckyc_info.perm_country= data.perm_country     
    user_ckyc_info.perm_pin= data.perm_pin
    user_ckyc_info.perm_state= data.perm_state      
    user_ckyc_info.email= data.email
    user_ckyc_info.gender= data.gender
    user_ckyc_info.mobile_number= data.mobile_number

    return user_ckyc_info
  },
}

// mutations
const mutations = {
  saveCkycDetails(state, payload) {
    state.ckycData = payload.data.data;
  },
  toggleLoading(state, flag) {
    state.loading = flag;
  },

  saveFileURL(state, payload) {
    state.fileUrl = payload;
  },
  savePDFUrl(state, payload) {
    state.pdf = payload;
  },

  saveUserCKycData(state, payload) {
    state.userCkycData = payload
    // state.userCkycData = {
    //   fullname: payload.fullname,
    //   father_fullname: payload.father_fullname,
    //   mother_fullname: payload.mother_fullname,
    //   spouse_fullname: payload.spouse_fullname,
    //   pan_number: payload.pan_number,
    //   date_of_birth: payload.date_of_birth,
    //   corres_line1: payload.corres_line1,
    //   corres_line2: payload.corres_line2,
    //   corres_line3: payload.corres_line3,
    //   corres_city: payload.corres_city,
    //   corres_state: payload.corres_state,
    //   corres_country:  payload.corres_country,
    //   corres_pin:  payload.corres_pin,
    //   perm_line1:  payload.perm_line1,
    //   perm_line2:  payload.perm_line2,
    //   perm_line3: payload.perm_line3,
    //   perm_city:  payload.perm_city,
    //   perm_state: payload.perm_state,
    //   perm_country:  payload.perm_country,
    //   perm_pin:  payload.perm_pin,
    //   gender:  payload.gender,
    //   email:  payload.email,
    //   mobile_number:  payload.mobile_number,  
    // }
  },
  saveCopyUserCKycData(state, payload) {
    let data = JSON.parse(JSON.stringify(state.userCkycData));

    state.copyUserCKycData = data;
  },

  updateCKycDetail(state, payload) {
    state.userCkycData[payload.key] = payload.value;
  },

  setKycStatus(state, payload) {
    state.kycStatus = payload;
  },
  cancelChanges(state) {
    let data = JSON.parse(JSON.stringify(state.copyUserCKycData));
    console.log(data)
    state.userCkycData = data;
  },
  removeUserDetails(state) {
    state.userCkycData = null;
    state.copyUserCKycData = null;
  },
  setcroppedImgUrl(state, payload) {
    state.croppedImgUrl = payload;
  },
  setSortingByDate(state,payload){
    let data = Object.keys(payload)[0];
    state[data] = payload[data];
  },
  toggleRejectCkyc(state,payload){
    state.tabs[payload.index].isReject = payload.value;
  },
  toggleCheckBoxCkyc(state,payload){
    console.log("toggleCheckBoxCkyc payload",payload)
    state.tabs[payload.index].checkDetails[payload.element] = payload.value
  },
  resetTabCkyc(state){
    state.tabs = [
      {
        name: "Personal",
        checkDetails: {
          name: false,
          dob: false,
        },
        isReject: true
      },
      {
        name: "Address",
        checkDetails: { address_status: false , address_validity: false},
        isReject: true
      },
      {
        name: "IPV",
        checkDetails: { gender: false, video: false },
        isReject: true
      },
      { name: "Approve", isReject: true }
    ]
  },
  updateCkycTab(state,payload){
    state.tabs = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
